export default {
  dga: {
    title: 'Vind een boekhouder voor de DGA salarisadministratie',
    subtitle:
      'Kom eenvoudig in contact met gekwalificeerde boekhouders voor de DGA salarisadministratie.',
    cta: 'Doorgaan'
  },
  bookkeeping: {
    title: 'Boekhouding',
    subtitle:
      'Je volledige boekhouding eenvoudig geregeld door onze specialisten. Persoonlijk contact en advies op maat. Kwaliteit tegen een scherp tarief.',
    cta: 'Doorgaan'
  },
  banner: {
    title: 'Reeds betaalde aanvragen kunt u hier nog afronden.',
    body:
      'Nieuwe aanvragen verlopen via ons vernieuwde platform. Heeft u vragen? Plan dan een adviesgesprek.',
    note: 'Let op. Je moet mogelijk opnieuw inloggen.',
    cta: 'Adviesgesprek'
  }
};
